<template>
  <div class="fullHeight">
    <BackButton />

    <div class="loader-block" v-if="load">
      <Loader />
    </div>

    <div v-else-if="!notAvailable && !load" class="player-container">
      <div class="player-block">
        <!-- Player -->
        <stampyt-360 v-if="loaded" :token="playerToken" :reference="reference"></stampyt-360>
      </div>
      <ContactInformationPlayer />
    </div>

    <div class="center-text" v-else>
      <p>{{ $t('publicPlayer.error') }}</p>
      <v-btn @click="shootingOptions" color="primary" :loading="loadingCustomBrand">{{
        $t('publicPlayer.refresh')
      }}</v-btn>
    </div>

    <div v-if="isStampytUser">
      <Webinaire :reference="reference" />
    </div>

    <v-expand-transition>
      <div v-if="!voted" class="my-5 px-2">
        <p class="rating-block-description">{{ $t('rating.description') }}</p>
        <Rating v-on:event-send-rating="sendRating" activeComments />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import BackButton from '@/components/BackButton.vue'
import ContactInformationPlayer from '@/components/ContactInformationPlayer.vue'
import Loader from '@/components/Loader.vue'
import Rating from '@/components/Rating.vue'
import Webinaire from '@/components/Webinaire.vue'

export default {
  name: 'Player',

  components: {
    BackButton,
    ContactInformationPlayer,
    Loader,
    Rating,
    Webinaire
  },

  data: function() {
    return {
      voted: false,
      playerToken: '',
      reference: '',
      downloadScript: '',
      loadedScript: false,
      playerV4ScriptUrl: '',
      isStampytUser: null,
      notAvailable: true,
      load: null
    }
  },

  computed: {
    ...mapState({
      loadingCustomBrand: state => state.loadingCustomBrand,
      user: state => state.user
    }),
    loaded() {
      return this.loadedScript
    }
  },

  async created() {
    const params = this.$route.params
    const ref = params && params.reference
    this.reference = ref

    if (ref) {
      this.sendNotification(ref)
      await this.shootingOptions()
    }

    this.loadEnvVariables()
    this.loadScript(this.downloadScript)
  },

  destroyed() {
    this.removeScript()
    this.$store.commit('RESET_LOGO_BRAND')
  },

  methods: {
    async sendRating(ob) {
      const { data, done } = ob
      data.ref = this.reference

      const res = await this.$store.dispatch('sendPlayerRating', { from: 'Player', data })
      if (res) {
        setTimeout(() => {
          this.voted = true
        }, 500)
      }

      done(res)
    },
    async shootingOptions() {
      if (!this.reference) return
      this.load = true

      const res = await this.$store.dispatch('shootingOptions', { id: this.reference, page: 'Player' })

      if (!res) {
        this.notAvailable = true
        this.load = false
      } else {
        this.notAvailable = false
        this.load = false
        this.isStampytUser = res.stampytUser
      }
    },
    sendNotification(ref) {
      this.$store.dispatch('notificationVideo', { ref: ref, type: 'watched' })
    },
    loadEnvVariables() {
      this.playerToken = window.env.PLAYER_TOKEN

      this.downloadScript = window.env.PLAYER_V4_COMPONENT_URL
    },

    loadScript(scriptUrl) {
      if (!scriptUrl || scriptUrl === '') {
        this.loadedScript = true
        return
      }
      const head = document.getElementsByTagName('head')[0]
      const script = document.createElement('script')
      script.id = 'stampyt-script-tag'
      script.type = 'text/javascript'
      script.onload = () => {
        this.loadedScript = true
      }
      script.src = scriptUrl
      head.appendChild(script)
    },

    removeScript() {
      const s = document.getElementById('stampyt-script-tag')
      const l = document.getElementById('stampyt-link-tag')

      if (s) {
        s.parentNode.removeChild(s)
      }

      if (l) {
        l.parentNode.removeChild(l)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.player-container
  display: flex
  justify-content: center
  flex-direction: row
  min-height: 500px
  @media screen and (max-width: 700px)
    flex-direction: column
    align-items: center

.player-block
  width: 100%
  max-width: 500px
  height: 500px
  position: relative
  padding: 20px

.backButtonBlock
  width: 100%
  margin: 30px 0
  padding-left: 20px

.fullHeight
  height: 100%
  overflow-y: auto

.loader-block
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center

.rating-block-description
  text-align: center
  opacity: .67
  margin: 20px auto

.rating-block-confirmation
  text-align: center
  font-size: 18px
  opacity: .67
</style>
